var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgHouseBlank = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.516 5.178a.748.748 0 0 1 .968 0l8.25 7a.749.749 0 1 1-.968 1.144l-.766-.65V18.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 6 18.5v-5.828l-.765.65a.75.75 0 0 1-.97-1.144l8.25-7zM7.5 11.4v7.1c0 .553.447 1 1 1h9c.553 0 1-.447 1-1v-7.1L13 6.733 7.5 11.4z",
    fill: "#1A202C",
    fillRule: "nonzero",
    stroke: "#1A202C",
    strokeWidth: 0.5
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHouseBlank, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/house-blank.74f3fb68.svg";
export { ForwardRef as ReactComponent };